module.exports = __webpack_public_path__ + "static/FL-fc5ebddce28dec08b92ca31664ae8065.svg";